import { Box, styled } from '@mui/material';

export const UploadFileDragContainer = styled(Box, {
  shouldForwardProp: (prop: string) => !['isDragging', 'isDisabledUploadFile'].includes(prop),
})<{ isDragging: boolean; isDisabledUploadFile: boolean }>(({ isDragging, isDisabledUploadFile, theme }) => ({
  border: `1px dashed ${isDragging ? theme.palette.case.aquamarine.a700 : theme.palette.case.neutral.n400}`,
  transition: 'all 0.3s',
  borderRadius: '8px',
  padding: '12px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',

  ...(isDisabledUploadFile && {
    background: theme.palette.case.neutral.n75,
  }),
}));

export const UploadFileDragWrapper = styled(Box, {
  shouldForwardProp: (prop: string) => !['isDisabledUploadFile'].includes(prop),
})<{ isDisabledUploadFile: boolean }>(({ isDisabledUploadFile, theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  cursor: 'pointer',
  svg: {
    height: '24px',
    width: '24px',
    marginBottom: '4px',
    path: {
      fill: theme.palette.case.neutral.n200,
    },
  },
  ...(isDisabledUploadFile && {
    cursor: 'default',
  }),
}));

export const UploadFileDragContentWrapper = styled(Box, {
  shouldForwardProp: () => true,
})(() => ({
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  alignItems: 'center',
}));
